import { CreateForm, FormTemplateProps, FormFieldsData } from 'framework/form';
import useActivityService from 'domain/sales/shared/timeline/activity/crmActivityService';
import { CreateTimelineItemLayout } from 'framework/ui/timeline';
import ActivityForm from 'domain/sales/shared/timeline/activity/form/ActivityForm';
import { useCompositeDocumentStorageContext, useCompositeDocumentStorageService } from 'domain/shared/documentStorage';
import { ENTITY_DOCUMENT_TYPE } from 'domain/sales/opportunity/shared/constants';

interface CreateActivityFormProps extends FormTemplateProps {
  onCancel: () => void;
  submitFormFunc: (values: FormFieldsData) => Promise<object | void>;
}

const CreateActivityForm = ({ submitFormFunc, onCancel, ...props }: CreateActivityFormProps) => {
  const { getValidationSchema } = useActivityService();

  const { isDocumentStorageAvailable } = useCompositeDocumentStorageContext();
  const { commitDocument } = useCompositeDocumentStorageService(isDocumentStorageAvailable);

  return (
    <CreateForm
      submitFormFunc={async data => {
        const artifactPath = data?.artifactPaths;
        const commitData = await commitDocument(artifactPath, ENTITY_DOCUMENT_TYPE.ACTIVITY_DOCUMENT);
        return submitFormFunc({ ...data, artifactPaths: commitData });
      }}
      getValidationSchemaFunc={getValidationSchema}
      initialData={{
        activityType: 'EMAIL',
      }}
      {...props}
    >
      <CreateTimelineItemLayout onCancel={onCancel}>
        <ActivityForm />
      </CreateTimelineItemLayout>
    </CreateForm>
  );
};

export default CreateActivityForm;
